import Vue from 'vue'
import VueRouter from 'vue-router'
import Body from '../components/Body.vue';
import dashboard from '../pages/dashboard.vue';
import SiteDashboard from '../pages/site-dashboard.vue';
import ProductsList from '../pages/products/ProductsList.vue';
import Reviews from '../pages/products/Reviews.vue';
import Order from '../pages/sales/orders/order.vue';
import Abondanedcart from '../pages/sales/abondaned/abondanedcart.vue';
import Customers from '../pages/sales/customers/customers.vue';
import Subscribers from '../pages/sales/subscribers/subscribers.vue';
import Contacts from '../pages/sales/contacts/contacts.vue';
import CouponList from '../pages/coupon/CouponList.vue';
import Auth from '../pages/authentication/index.vue';
import Userauth from '../auth/index.js'
import firebase from '../utils/firestore-shim';
import { currentEntitlement, isKnownUnpaid } from '../utils/entitlement';
import ListsArticles from '../pages/blogs/ListsArticles.vue';
import List from '../pages/blogs/List.vue';
import store from '../pages/stores/general/store.vue';
import theme from '../pages/stores/themes/theme.vue';
import sliders from '../pages/stores/sliders/sliders.vue';
import IndexCategories from '../pages/stores/categories/index-categories.vue';
import SocialMedia from '../pages/stores/social-media/social-media.vue';
import shipping from '../pages/stores/shipping/shipping.vue';
import payment from '../pages/stores/payment/payment.vue';
import emails from '../pages/stores/emails/emails.vue';
import sms from '../pages/stores/sms/sms.vue';
import bigbuy from '../pages/stores/bigbuy/bigbuy.vue';
import BigBuyImport from '../pages/products/BigBuyImport.vue';
import eprolo from '../pages/stores/eprolo/eprolo.vue';
import EproloImport from '../pages/products/EproloImport.vue';
import AccountProfile from '../pages/account/profile.vue';
import AccountSubscription from '../pages/account/subscription.vue';
import PaymentCallback from '../pages/account/callback.vue';
import AdminOverview from '../pages/superadmin/overview.vue';
import AdminSubscribers from '../pages/superadmin/subscribers.vue';
import AdminPayments from '../pages/superadmin/payments.vue';
import AdminPlans from '../pages/superadmin/plans.vue';
import AdminStores from '../pages/superadmin/stores.vue';
import AdminEvents from '../pages/superadmin/events.vue';
Vue.use(VueRouter)

const routes = [ 
    { path: '', redirect: { name: 'default' } },
    {
        path: '/dashboard',
        component: Body,
        children: [{
            path: 'default',
            name: 'default',
            component: dashboard,
            meta: {
                title: 'Sablior - Admin',
            }
        }, {
            path: 'site',
            name: 'site-dashboard',
            component: SiteDashboard,
            meta: {
                title: 'Site Dashboard | Admin',
            }
        }]
    },
    {
        path: '/products',
        component: Body,
        children: [
            {
                path: 'reviews',
                name: 'reviews',
                component: Reviews,
                meta: {
                    title: 'Reviews | Admin',
                }
            },
            {
                path: 'products-list',
                name: 'products-list',
                component: ProductsList,
                meta: {
                    title: 'Product List | Admin',
                }
            },
            {
                path: 'bigbuy-import',
                name: 'bigbuy-import',
                component: BigBuyImport,
                meta: {
                    title: 'BigBuy Import | Admin',
                }
            },
            {
                path: 'eprolo-import',
                name: 'eprolo-import',
                component: EproloImport,
                meta: {
                    title: 'EPROLO Import | Admin',
                }
            }
        ]
    },
    {
        path: '/stores',
        component: Body,
        children: [
            {
                path: 'products-list',
                name: 'products-list',
                component: ProductsList,
                meta: {
                    title: 'Product List | Admin',
                }
            },
            {
                path: 'store',
                name: 'store',
                component: store,
                meta: {
                    title: 'Store | Admin',
                }
            },
            {
                path: 'theme',
                name: 'theme',
                component: theme,
                meta: {
                    title: 'Theme | Admin',
                }
            },
            {
                path: 'sliders',
                name: 'sliders',
                component: sliders,
                meta: {
                    title: 'Sliders | Admin',
                }
            },
            {
                path: 'index-categories',
                name: 'index-categpries',
                component: IndexCategories,
                meta: {
                    title: 'Categories | Admin',
                }
            },
            {
                path: 'social-media',
                name: 'social-media',
                component: SocialMedia,
                meta: {
                    title: 'Social Media | Admin',
                }
            },
            {
                path: 'shipping',
                name: 'shipping',
                component: shipping,
                meta: {
                    title: 'Shipping | Admin',
                }
            },
            {
                path: 'payment',
                name: 'payment',
                component: payment,
                meta: {
                    title: 'Payment | Admin',
                }
            },
            {
                path: 'emails',
                name: 'emails',
                component: emails,
                meta: {
                    title: 'E-mail | Admin',
                }
            },
            {
                path: 'sms',
                name: 'sms',
                component: sms,
                meta: {
                    title: 'SMS | Admin',
                }
            },
            {
                path: 'bigbuy',
                name: 'bigbuy',
                component: bigbuy,
                meta: {
                    title: 'BigBuy | Admin',
                }
            },
            {
                path: 'eprolo',
                name: 'eprolo',
                component: eprolo,
                meta: {
                    title: 'EPROLO | Admin',
                }
            }
        ]
    },
    {
        path: '/sales',
        component: Body,
        children: [{
                path: 'order',
                name: 'order',
                component: Order,
                meta: {
                    title: 'Order | Admin',
                }
            },
            {
                path: 'abondanedcart',
                name: 'abondanedcart',
                component: Abondanedcart,
                meta: {
                    title: 'Abondanedcart | Admin',
                }
            },
            {
                path: 'customers',
                name: 'customers',
                component: Customers,
                meta: {
                    title: 'Customers | Admin',
                }
            },
            {
                path: 'subscribers',
                name: 'subscribers',
                component: Subscribers,
                meta: {
                    title: 'Subscribers | Admin',
                }
            },
            {
                path: 'contacts',
                name: 'contacts',
                component: Contacts,
                meta: {
                    title: 'Contacts | Admin',
                }
            }
        ]
    },
    {
        path: '/coupons',
        component: Body,
        children: [{
                path: 'coupon-list',
                name: 'coupon-list',
                component: CouponList,
                meta: {
                    title: 'Coupon | Admin',
                }

            }
        ]
    },
    {
        path: '/auth/login',
        name: 'login',
        component: Auth,
        meta: {
            title: 'Login | Admin',

        }
    },
    {
        path: '/blog',
        component: Body,
        children: [
            {
                path: 'articles',
                name: 'lists-articles',
                component: ListsArticles,
                meta: {
                    title: 'Listes Blogs | Admin',
                }
            },
            {
                path: 'list',
                name: 'list',
                component: List,
                meta: {
                    title: 'Listes Blogs | Admin',
                }
            }
        ]
    },
    {
        path: '/account',
        component: Body,
        children: [
            {
                path: 'profile',
                name: 'account-profile',
                component: AccountProfile,
                meta: {
                    title: 'My Profile | Admin',
                }
            },
            {
                path: 'subscription',
                name: 'account-subscription',
                component: AccountSubscription,
                meta: {
                    title: 'Subscription | Admin',
                }
            }
        ]
    },
    {
        path: '/callback',
        name: 'callback',
        component: PaymentCallback,
        meta: {
            title: 'Payment | Admin',
        }
    },
    {
        path: '/admin',
        component: Body,
        children: [
            {
                path: 'overview',
                name: 'admin-overview',
                component: AdminOverview,
                meta: {
                    title: 'Super Admin - Overview',
                    superadmin: true
                }
            },
            {
                path: 'subscribers',
                name: 'admin-subscribers',
                component: AdminSubscribers,
                meta: {
                    title: 'Super Admin - Subscribers',
                    superadmin: true
                }
            },
            {
                path: 'payments',
                name: 'admin-payments',
                component: AdminPayments,
                meta: {
                    title: 'Super Admin - Payments',
                    superadmin: true
                }
            },
            {
                path: 'plans',
                name: 'admin-plans',
                component: AdminPlans,
                meta: {
                    title: 'Super Admin - Plans',
                    superadmin: true
                }
            },
            {
                path: 'stores',
                name: 'admin-stores',
                component: AdminStores,
                meta: {
                    title: 'Super Admin - Stores',
                    superadmin: true
                }
            },
            {
                path: 'events',
                name: 'admin-events',
                component: AdminEvents,
                meta: {
                    title: 'Super Admin - Activity',
                    superadmin: true
                }
            }
        ]
    }
]


const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes
})

// Pages accessibles sans session ni abonnement.
const PUBLIC_PATHS = ['/auth/login', '/register', '/callback'];
// Pages de compte : toujours accessibles (un compte sans abonnement doit
// pouvoir gérer son profil et souscrire).
const ACCOUNT_PATHS = ['/account/profile', '/account/subscription'];

// Garde de navigation :
//  - la session admin (jeton JWT dans localStorage, posé par
//    utils/firestore-shim.js à la connexion, voir auth/index.js) est requise
//    sauf pour les pages publiques ;
//  - un abonnement actif est requis pour le reste de l'admin : un compte
//    sans abonnement actif est renvoyé vers /account/subscription (la
//    sidebar n'y affiche que Profil et Abonnement). Le super-admin et les
//    comptes payants accèdent à tout.
router.beforeEach(async (to, from, next) => {
    if (to.meta.title)
        document.title = to.meta.title;

    if (PUBLIC_PATHS.includes(to.path)) return next();
    if (!Userauth.isAuthenticatedUser()) return next('/auth/login');

    // Droits d'usage : lit le cache réactif ; s'il est absent (première
    // navigation après connexion, localStorage vidé...), charge le profil
    // une fois pour trancher sans bloquer à tort un compte payant.
    let entitlement = currentEntitlement();
    if (!entitlement) {
        try {
            const profile = await firebase.auth().fetchProfile();
            Userauth.setProfile(profile);   // met à jour cache + état réactif
            entitlement = currentEntitlement();
        } catch (e) {
            entitlement = null;
        }
    }

    if (ACCOUNT_PATHS.includes(to.path)) return next();
    // Super-admin : confiné à la zone /admin/* (Overview, Subscribers,
    // Payments, Plans, Stores, Activity). Tout autre écran de l'admin
    // (tableau de bord owner, boutiques, compte) est renvoyé vers
    // /admin/overview, cohérent avec la sidebar qui ne montre que ces menus.
    if (entitlement && entitlement.superadmin) {
        if (String(to.path).indexOf('/admin') === 0) return next();
        return next('/admin/overview');
    }
    // Pages super-admin : réservées au rôle superadmin ; tout autre compte
    // (owner payé ou non) est renvoyé vers le tableau de bord.
    if (to.meta.superadmin && !(entitlement && entitlement.superadmin)) return next('/dashboard/default');
    if (isKnownUnpaid(entitlement)) return next('/account/subscription');
    return next();
});

export default router